export default {
  id: 'push_gamification',
  title: 'Gamification update',
  type: 'Direct',
  canSendToChannel: false,
  description: 'Send a message to view the leaderboard/collective goal for this campaign.',
  body: {
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '[[INPUT_MESSAGE_TEXT]]'
        }
      },
    ],
  },
  inputs: {
    INPUT_MESSAGE_TEXT: {
      label: 'Message',
      placeholder: 'Check out the current standings of our campaign…',
      defaultValue: 'Check out the current standings of our campaign!',
      type: 'HTML'
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/push/gamificationUpdate.js